export const tcoDuplicatedClusterTable = [
    {
      display_name: "",
      key: "select",
      headerStyles: {
        background: "#7593F2",
        color: "#ffffff",
        padding: "4px 8px",
        width: "50px",
      },
      cellStyles: {
        width: "50px",
      },
      _config: {
        type: "checkbox",
        displayInColumn: true,
        value: "id",
        isClickable: "true",
      },
    },
    {
      display_name: "Test ID",
      headerStyles: {
        width: "10%",
      },
      key: "testId",
    },
    {
      display_name: "Test Case Name",
      key: "testName",
    },
    {
      display_name: "Test Description",
      key: "description",
    },
    {
      display_name: "Remarks",
      key: "remarks",
    },
    {
      display_name: "Recommendation",
      key: "retain",
    },
  ];
  